module.exports = __webpack_public_path__ + "static/img/banner06.891e8baa.png";